import { BROWSER_SESSION, isSessionType } from '~/types'

export default defineNuxtRouteMiddleware(async (to) => {
  if (
    import.meta.server // Skip on server-side
      || to.meta.auth === false // Skip authentication for specific routes
      || to.matched.length === 0 // Skip authentication for 404 pages
  ) {
    return
  }

  if (to.meta.auth === undefined)
    throw new Error('Page meta "auth" is required.')

  // We use `auth` meta to assign proper authentication session
  if (!isSessionType(to.meta.auth)) {
    throw new Error('Page meta \'auth\' must be a valid session type')
  }

  const sessionStore = to.meta.auth === BROWSER_SESSION
    ? useBrowserSessionStore()
    : useBuilderSessionStore()

  if (!await sessionStore.checkAuth()) {
    return navigateTo({
      name: 'error-title',
      params: { title: 'unauthorized' },
    }, { replace: true })
  }
})
